import React from 'react';

const Home = () => {
  React.useEffect(() => {
    //window.location.replace('https://motorsportgames.com/')
  }, [])
    
  return (
    <div className='container-fluid'>
      <div className='col-xl'>
      </div>
    </div>
  );
};

export default Home;
